import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dismiss: {
		id: 'home-common-ui.promotional-card.dismiss',
		defaultMessage: 'Close',
		description: 'Label for "close" button which will close the promotional card',
	},
	footerContent: {
		id: 'home-common-ui.promotional-card.footer-content',
		defaultMessage: 'Why am I seeing this?',
		description: 'Tooltip trigger to explain why the user is targeted for promotional message',
	},
});
